<template>
    <div>
            <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
                <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
             <v-row class="bradcrumb">
             <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link>
        <!-- <router-link :to="{name: 'eps-admin-master-menu' }" class="root">
            Super Master
        </router-link> -->
        <span class="child">/ Add Proctor </span>
    </v-row><br />
    <center class="heading">
        <h3>Add Proctor</h3>
    </center>
    <!-- <span v-if="org!=null">
        <center>
            <h3>
                <v-chip class="ma-2" color="indigo" text-color="white">
                    <v-avatar left>
                        <v-icon size="22">home_work</v-icon>
                    </v-avatar>
                    {{org}}
                </v-chip>
            </h3>
        </center>
        </span> -->
        <v-card>
              <v-container>
            <v-row>
                <v-col cols="12">
                    <v-toolbar-title>Import Proctor</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <!-- <v-file-input placeholder="CSV of Proctor Data" prepend-icon="mdi-file" label="Proctor Data" show-size v-model="file"></v-file-input> -->
                    <v-file-input dense accept=".csv" v-model="file" :hint="file != null? '':'Please Select File'" persistent-hint color="rgb(1, 127, 152)" label="Choose File" prepend-icon="mdi-paperclip" outlined :show-size="1000">
                            </v-file-input>
                </v-col>
              
                 <v-col cols="4">
                <!-- <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn> -->
                </v-col>
                <v-col cols="4">
                    <a href="https://easypariksha.s3.ap-south-1.amazonaws.com/import_excel_csv_file/Import_Proctor_Sample.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="success" class="ma-2 white--text downbtn " @click="loader = 'loading3'">
                            <v-icon left dark>mdi-cloud-download</v-icon>
                            Download import CSV format
                        </v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row>
                        <v-col cols="4">
                            <center>
                                <v-btn @click="submitFile" :loading="output_load" class="button">
                                    Upload
                                    <v-icon right>mdi-cloud-upload</v-icon>
                                </v-btn>
                            </center>
                        </v-col>
                    </v-row>
        </v-container>
        </v-card>
        <br>
        <v-card>
            <template v-if="load==true">
                <v-data-table :headers="headers" :items="proctor_list1" sort-by="ptype" class="elevation-1" :search="search">
                    <template v-slot:top>
                        <v-toolbar flat color="white">
                            <v-toolbar-title>Proctor</v-toolbar-title>
                            <v-divider class="mx-4" inset vertical></v-divider>
                            <v-spacer></v-spacer>
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                            <span style="width: 20px"></span>
                             <template>
                                    <v-btn class="button" @click="dialog_add=true" ><v-icon left dark>mdi-account-plus</v-icon>Add New Proctor</v-btn>
                            </template>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.isactive="{ item }">
                        <span v-if="item.isactive">
                                <v-icon color="success" class="mr-2">mdi-check-circle-outline</v-icon>
                    </span>
                        <span v-else>
                            <v-icon  color="error" class="mr-2">mdi-close-circle-outline</v-icon>
                    </span>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-avatar style="" size="33" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" size="18" @click="editItem(item)">mdi-pencil</v-icon>
                        </v-avatar>
                    </template>
                    <!-- <div>
                            <v-avatar style="" size="33" class="edit-avatar">
                                <v-icon class="edit-v-icon mr-2" size="18" @click="editItem(item)">mdi-pencil</v-icon>
                            </v-avatar>
                        </div> -->
                </v-data-table>
                
                <div v-if="instnotfound" style="color:red">
                    <v-simple-table style="color:red;">
                        <h2></h2>
                        <template >
                        <thead>
                            <tr>
                            <th class="text-left">Sr. No.</th>
                            <th class="text-left">Instructor not Found</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  v-for="snot in instnotfound" :key="snot.instcode">
                            <td>{{ snot.srno}}</td>
                            <td> {{ snot.instcode }}</td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>    
                </div>
            </template>
        </v-card>
            <v-dialog v-model="dialog_edit" max-width="500px">
                <v-card>
                    <v-card-title class="heading">
                        <span>Edit Proctor</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" >
                                  
                                        <v-autocomplete dense v-model="editedItem.examname" :items="exam_List1" 
                                        item-text='examname'
                                        item-value="examname"
                                        label="Select Exam"
                                        ></v-autocomplete>
                                       
                                </v-col>
                                <v-col cols="12" >
                                        <v-autocomplete dense v-model="editedItem.proctor_code" :items="proctor_list1" 
                                        item-text='proctor_code'
                                        item-value="proctor_code"
                                        label="Select Proctor"
                                        disabled
                                        filled
                                        hint="Proctor cannot be changed!"
                                        persistent-hint
                                        ></v-autocomplete>
                                </v-col> 
                                  <v-col cols="12" >
                                         <v-checkbox
                                            v-model="editedItem.checkbox"
                                            label="Is Active"
                                        ></v-checkbox>
                                </v-col>                                            
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button-cancel" text @click="close">Close</v-btn>
                        <v-btn class=" button" @click="update">Update</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
             <v-dialog v-model="dialog_add" max-width="500px">
                <v-card>
                    <v-card-title class="heading">
                        <span>Add New Proctor</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" >
                                        <v-autocomplete dense v-model="add.exam" :items="exam_List1" 
                                        item-text='examname'
                                        item-value="exam_id"
                                        label="Select Exam"
                                        :hint="add.exam != null? '':'Please Select Exam'"
                                        persistent-hint
                                        ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" >
                                    <v-autocomplete dense v-model="add.inst" :items="inst_List1" 
                                        item-text='emp_code_name'
                                        item-value="inst_id"
                                        label="Select Instructor"
                                        :hint="add.inst != null? '':'Please Select Instructor'"
                                        persistent-hint
                                        ></v-autocomplete>
                                </v-col>                                           
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="button-cancel" text @click="close">Close</v-btn>
                        <v-btn class=" button" @click="add_new()">Add</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
       <v-dialog
            v-model="dialog_send"
            hide-overlay
            persistent
            width="300"
            >
            <v-card
                color="#4CAF50"
                dark
            >
            <v-card-text>
            "Please wait..." {{dialog_send_msg}}
            <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
            ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
import "@/assets/css/color.css";
    import axios from "axios";
    export default {
        data: () => ({
            errorMsg: {
                exam: false,
                inst : false,
               
            },
            add:{
                inst:null,
                exam:null
            },
           
            dialog_send:false,
            file: null,
            loading3: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            load: false,
            dialog_edit: false,
            dialog_add:false,
            exam_List1:null,
            inst_List1:null,
            org:null,
            proctor_list1:null,
            dialog_send_color:'',
            dialog_send_msg:'',
            output_load:false,
            headers: [
            { text: "Sr.No.", value: "srno" },
            { text: "Exam", value: "examname" },
            { text: "Proctor Name", value: "proctor_code" },
            { text: "Status", value: "isactive" },
            { text: "Actions", value: "actions", sortable: false }, ],

            editedIndex: -1,
            editedItem: {
                proctor_code:'',
                pid:'',
                checkbox:null,
                examname:'',
                emp_code_name:'',
                inst_id:'',
                exam_id:''
            },
             defaultval:[{
                examname:'ESE',
                isactive:true,
                id:2
            }],
            instnotfound:null,
            
        }),
       
        mounted() {
            axios
                .post("AdminImport/importProctorHome")
                .then(res => {
                    if (res.data.msg == "200") {
                        this.proctor_list1 = res.data.proctor_list;
                        this.exam_List1 = res.data.exam_List;
                        this.inst_List1 = res.data.inst_List
                        this.org = res.data.org
                        this.load = true;
                    } else {}
                })
                .catch(error => {
                    window.console.log(error);
                });
        },

        methods: {
          loadData(){
                axios
                .post("AdminImport/importProctorHome")
                .then(res => {
                    if (res.data.msg == "200") {
                        this.proctor_list1 = res.data.proctor_list;
                        this.exam_List = res.data.exam_List;
                        this.inst_List = res.data.inst_List
                        this.load = true;
                    } else {}
                })
                .catch(error => {
                    window.console.log(error);
                });
          } , 
          setfilenull()
          {
               this.file=null
          },
          submitFile() {
                if (this.file == null) {
                  this.showSnackbar("#b71c1c", "Please select the file!");
                  //alert("Please select the file!");
                } else {
                  this.output_load = true;
                  this.dialog_send=true;
                  this.dialog_send_msg='while file is Importing?'
                  let formData = new FormData();
                  formData.append("file", this.file);
                  axios
                    .post("AdminImport/importProctor", formData, {
                      headers: {
                        "Content-Type": "multipart/form-data"
                      }
                    })
                    .then(res => {
                      if (res.data.msg == "200") {

                        this.instnotfound = res.data.proctorList;
                        this.load = true;
                        this.output_load = false;
                        this.dialog_send=false;
                        this.loadData();
                        this.showSnackbar("#4CAF50", "Partial Proctors Imported Successfully...");
                        this.setfilenull()
                      }else{
                        this.output_load = false;
                        this.dialog_send=false;
                        this.showSnackbar("#b71c1c", res.data.proctorList);
                      }
                    })
                    .catch(function() {
                      console.log("FAILURE!!");
                    })
                    .finally(() => {
                      this.output_load = false;
                    });
                  //     }
                }
              },//end of the fuction

                showSnackbar(clr, msg) {
                    this.snackbar = true;
                    this.color = clr;
                    this.snackbar_msg = msg;
                },
                editItem(item) {
                    // console.log(item)
                    // window.alert("item.examname id: "+item.examname+" item.proctor_id: "+item.proctor_id)
                    this.dialog_edit = true;
                    this.editedItem.pid=item.proctor_id
                    this.editedItem.checkbox=item.isactive
                    this.editedItem.examname=item.examname
                    this.editedItem.proctor_code=item.proctor_code
                    this.editedItem.inst_id = item.inst_id
                    this.editedItem.exam_id = item.examid
                    this.defaultval.proctor_code=item.proctor_code
                    //this.editedIndex = this.course_list.indexOf(item);
                },

                close() {
                    this.dialog = false;
                    this.output_load = false;
                    this.dialog_send=false;
                    this.dialog_add=false;
                    this.dialog_edit=false
                    //this.initializeErrorMsgFalse();
                    setTimeout(() => {
                        this.editedItem = Object.assign({}, this.defaultItem);
                        this.editedIndex = -1;
                    }, 300);
                },

                add_new() {
                    if (this.add.exam==null)
                    {
                        this.showSnackbar("#b71c1c", "Select Exam !!!");
                    }else if(this.add.inst==null){
                        this.showSnackbar("#b71c1c", "Select  Instructor!!!");
                    }else{
                        this.dialog_send=true
                        this.dialog_send_msg="Proctor Adding!!!"
                        axios
                        .post("AdminImport/addProctor", this.add)
                        .then(res => {
                            
                            if (res.data.msg_add == "2001") {
                                this.dialog_send=false;
                                this.loadData()
                                this.showSnackbar("#4caf50", "Proctor Added Successfully..."); // show snackbar on success
                            }else{
                                this.dialog_send=false;
                                this.dialog_add=false;
                                this.showSnackbar("#b71c1c", res.data.msg_status);
                            }
                        })
                        .catch(error => {
                            window.console.log(error);
                        })
                        .finally(() => {
          this.add.inst = null;
          this.add.exam = null;

        });
                    this.close();
                    }               
                }, // end of save()
                update() {
                    if (this.editedItem.examname==null)
                    {
                        this.showSnackbar("#b71c1c", "Select Exam !!!");
                    }else if(this.editedItem.proctor_code==null){
                        this.showSnackbar("#b71c1c", "Select  Instructor!!!");
                    }else{
                        this.dialog_send=true
                        this.dialog_send_msg="Proctor Updating !!!"
                        axios
                        .post("AdminImport/editProctor", this.editedItem)
                        .then(res => {
                            if (res.data.msg_add == "2001") {
                                this.dialog_send=false;
                                this.loadData()
                                this.showSnackbar("#4caf50", "Proctor Details Updated Successfully..."); // show snackbar on success
                            }else{
                                this.dialog_send=false;
                                this.dialog_add=false;
                                this.loadData()
                                this.showSnackbar("#b71c1c", res.data.msg_status);
                            }
                        })
                        .catch(error => {
                            window.console.log(error);
                        });
                    this.close();
                    }               
                }, // end of save()
        }
    };
</script>
<style scoped>
    .downbtn {
    float: right;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    
    .v-icon-size {
        font-size: 20px;
    }
    
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    
    .edit-v-icon:hover {
        color: white;
    }
</style>